import {forwardRef, useEffect, useImperativeHandle, useState} from "react";
import {Button, Input, List, message, Modal} from "antd";
import {TFolder, TNote} from "../../index";
import {CheckOutlined, FolderOutlined, SearchOutlined} from "@ant-design/icons";
import {allFolder} from "@model/folder";
import {getImagePathWithTheme, isStringNullOrEmpty} from "@/utils";
import {useTranslation} from "react-i18next";
import {getNoteById, getNoteList, updateNote} from "@model/note";
import {postMessage} from "@/common/event";
import {EVENT_MOVE_FOLDER, EVENT_NOTE_CHANGED} from "@/Const";
import {IconClose, IconSearch} from "@/Icon";

let mArrayFolders:any=[];
let mNoteData;
const DialogMovetoFolder = forwardRef((props, ref) => {
    useImperativeHandle(ref,()=>({
        onShowDialogEvent:onShowDialogEvent
    }));
    const {t} = useTranslation();
    const [isShowDialog,setIsShowDialog] = useState(false);
    const [arrayFolders,setArrayFolders] = useState([]);
    const [selectFolder,setSelectFolder] = useState(null);
    const [isMoveDisable,setIsMoveDisable] = useState(true);

    useEffect(()=>{

    },[]);

    const onShowDialogEvent = (noteData:TNote)=>{
        mNoteData = noteData;
        setIsShowDialog(true);
        allFolder().then(res=>{
            res.sort((a,b)=>{
                return a.createTime - b.createTime;
            })
            res.forEach(p=>p.isSelect = false);
            mArrayFolders = res;
            let hasInFolder = false;
            if (!isStringNullOrEmpty(noteData.folderId)){
                var arrayTmp = res.filter(p=>p.id == noteData.folderId);
                if (arrayTmp.length > 0){
                    arrayTmp[0].isSelect = true;
                    setSelectFolder(arrayTmp[0]);
                    setIsMoveDisable(true);
                    hasInFolder = true;
                }
            }

            setArrayFolders([{id:'',name:t("All"),isSelect:!hasInFolder},...res]);
        })
    }

    /**
     * 选择
     * @param e
     */
    const onItemClick = (e)=>{
        var nIndex = e.currentTarget.dataset.index;
        var arrayNew = [...arrayFolders];
        arrayNew.forEach(p=>p.isSelect = false);
        var item = arrayNew[nIndex];
        item.isSelect = true;
        setSelectFolder(item);
        setArrayFolders(arrayNew);

        setIsMoveDisable(item.id == mNoteData?.folderId);
    }

    /**
     * 搜索
     * @param e
     */
    const onSearchEvent = (e)=>{
        var szKey = e.currentTarget.value;
        var arrayTmp = mArrayFolders.filter(p=>p.name.indexOf(szKey) != -1);
        arrayTmp.forEach(p=>{
            p.isSelect = false;
            if (p.id == selectFolder?.id){
                p.isSelect = true;
            }
        })
        setArrayFolders(arrayTmp);
    }

    /*移动到....*/
    const onMoveEvent  = async()=>{
        if (selectFolder != null && selectFolder != undefined){
            //note 并更新...
            mNoteData.folderId = selectFolder.id;
            mNoteData.updateTime = new Date().getTime();
            await updateNote(mNoteData);
            setIsShowDialog(false);
            postMessage(EVENT_NOTE_CHANGED);
            postMessage(EVENT_MOVE_FOLDER);
            message.info(t("Has moved to")+" "+selectFolder.name);
        }
    }

    return(
        <Modal visible={isShowDialog}
               footer={''}
               closable={true}
               width={320}
               centered={true}
               destroyOnClose={true}
               closeIcon={<IconClose/>}
               bodyStyle={{maxHeight:'640px'}}
               onCancel={()=>setIsShowDialog(false)}>
            <div>
                <h3 style={{width:'100%',textAlign:'left'}}>{t("Move to folder")}</h3>
                <Input className={'input-border'} style={{marginTop:'16px',backgroundColor:'transparent'}} variant={"borderless"} prefix={<IconSearch />} placeholder={t("Search")} onChange={onSearchEvent}/>
                <div style={{height:'12px'}}></div>

                <div style={{maxHeight:'300px', overflow:'auto'}} className='ul-item'>
                    <List
                        split={false}
                        itemLayout="horizontal"
                        dataSource={arrayFolders}
                        renderItem={(item, index) => (
                            <List.Item style={{height:'32px'}} data-index={index} onClick={onItemClick}>
                                <div className='flex-row-vertical-center' style={{width:'100%'}}>
                                    <img className={'img-16'} src={getImagePathWithTheme('move_to_folder')} style={{marginLeft:'-6px'}}/>
                                    <span style={{marginLeft:'12px',flexGrow:'1'}}>{item.name}</span>
                                    <img className={'img-mini-small-12'} src={item.isSelect?getImagePathWithTheme('icon_check_blue'):getImagePathWithTheme("icon_uncheck")} style={{float:'right',marginRight:'6px'}}/>
                                </div>
                            </List.Item>
                        )}
                    />
                </div>

                <Button className='button-solid-style' disabled={isMoveDisable} onClick={onMoveEvent} style={{height:'36px',width:'100%',marginTop:'12px',marginBottom:'-12px'}} type={"primary"}>{t("Move to")+" "+ (selectFolder?.name || '')}</Button>
            </div>
        </Modal>
    )
});
export default DialogMovetoFolder;




























